import React, { useEffect, useState } from "react";
import Logo from "../Images/aivops logo.png";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

 

  const submit =async (e) => {
    e.preventDefault();
    console.log(email, password);
    if (email === "admin@aivirtualops.com" && password === "adminaivirtualops") {
      try {
        // Set the cookie
        Cookies.set("user", "admin", { expires: 7 });
  
        // If correct, show success toast
        toast.success("Login Successful", {
          position: toast.POSITION.TOP_CENTER,
        });
  
        // Use setTimeout to delay the navigation after setting the cookie
        setTimeout(() => {
          // navigate('/getall');
          window.location.reload()
        }, 3000); // You can adjust the delay time if needed
      } catch (error) {
        console.error("Error setting cookie:", error);
      }
    } else {
      // If incorrect, show error toast
      toast.error("Invalid Username or Password", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  useEffect(()=>{
  if(Cookies.get("user")){
    navigate('/')
  }
  },[])


  return (
    <div className=" min-h-screen" style={{ background: "#89c8ff" }}>
      <div
        className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8 mt-11"
        style={{ background: "#89c8ff" }}
      >
        <div className="sm:mx-auto sm:w-full sm:max-w-sm flex-col justify-items-center flex">
          <img className="mx-auto  h-20 mt-4" src={Logo} alt="Your Company" />
          <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
            Sign in to your account
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form className="space-y-6" onSubmit={submit}>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium leading-6 text-gray-900"
              >
                Email address
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="block w-full rounded-md border-0 py-1.5  px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label
                  htmlFor="password"
                  className="block text-sm font-medium leading-6 text-gray-900"
                >
                  Password
                </label>
                {/* <div className="text-sm">
                  <a
                    href="#"
                    className="font-semibold text-indigo-600 hover:text-indigo-500"
                  >
                    Forgot password?
                  </a>
                </div> */}
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="block w-full rounded-md border-0 py-1.5  px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                style={{border:'2px solid rgba(79,72,299,0.3)'}}
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Sign in
              </button>
            </div>
          </form>

          <p className="mt-10 text-center text-sm text-gray-500">
            Not a member?{" "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
